@if(componentModel){
    <div class="relative group w-full min-w-64 h-64 bg-gray-100 rounded-md overflow-hidden">
        <!-- Poster Image -->
        @if (componentModel?.image?.value) {
            <img
                    [src]="componentModel?.image?.value"
                    alt="Video Poster"
                    class="w-full h-full object-cover"
            />
        }
        @if(componentModel?.video?.value){
            <!-- Play Button Overlay -->
            <div (click)="playVideo()" class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <button
                        class="flex items-center justify-center w-16 h-16 rounded-full bg-primary text-normal hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-button-primary-outline"
                        aria-label="Play Video"
                >
                    <svg class="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                    </svg>
                </button>
            </div>
        }


        <!-- Gradient Overlay with Text -->
        <div class="absolute bottom-0 w-full bg-gradient-to-t from-black via-black/60 to-transparent text-white p-4">
            <h2 class="text-lg font-semibold">{{componentModel?.title?.value}}</h2>
            <p class="text-sm">{{componentModel?.description?.value}}</p>
            <p class="text-xs mt-1">{{componentModel?.metaData?.value}}</p>
        </div>
    </div>
}

